export default __webpack_public_path__ + "static/media/11-min.51eab264.jpg";